module.exports = __webpack_public_path__ + "media/metronic/_theme/media/icons/svg/Design/Target-e7614ef58b65582ec1bb66e522875041.svg";